"use client"
import dynamic from 'next/dynamic'

// Load only on client and keep bundle lean
const PwaDebug = dynamic(() => import('../../src/components/PwaDebug'), { ssr: false })

export default function PwaShell() {
  return (
    <>
      <PwaDebug />
    </>
  )
}
